export default __webpack_public_path__ + "static/img/unicum-icon-overlay.f950b7a.png";